<template>
    <div class="question">
        <p v-if="question.question">{{question.question}}</p>

        <template v-if="question.type === 'rate'">
            <rate-box :choices="question.answers" :name="question.name" v-on:change="forwardValue"></rate-box>
        </template>

        <template v-else-if="question.type === 'choose'">
            <p v-for="answer in question.answers" :key="answer">
                <label><input type="radio" :name="question.name" :value="answer" autocomplete="off" />
                    {{answer}}
                </label>
            </p>
        </template>


        <template v-else-if="question.type === 'choose_info'">
            <select v-model="selected" :name="question.name" >
                <option value="" disabled selected hidden key="none">Ausw&auml;hlen</option>
                <option v-for="answer in question.answers" :key="answer" :value="answer">
                    {{answer}}
                </option>
            </select>
        </template>

        <template v-else-if="question.type === 'checkbox'">
            <label class="checkbox_label" v-for="answer in question.answers" :key="answer"><input type="checkbox" v-model="checked" :name="question.name" :value="answer"><span class="checkbox"></span><span class="label">{{ answer }}</span></label>
        </template>

        <template v-else-if="question.type === 'text'">
            <textarea v-model="selected" :name="question.name" rows="4" cols="80" placeholder="Meine Antwort ..."></textarea>
        </template>
    </div>
</template>

<script>
	import RateBox from './RateBox/RateBox';

	export default {
		name: "QuestionsBox",
		data() {
			return {
				selected : '',
                checked : []
            };
		},
		props: {
			question: {
				type: Object,
				required: true
			}
		},
		methods: {
			forwardValue ( val ) {
				this.selected = val;
            }
        },
		components: {
			'rate-box': RateBox
		},
        watch : {
	        selected: function ( val ) {
		        this.$emit('change', {value: val, name: this.question.name});
	        },
            checked: function( val ) {
	            this.$emit('change', {value: val, name: this.question.name})
            }
        }

	};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/subparts/QuestionsBox.vue